/* Dog Socky - Sizing Widget i18n | assets/sizing-widget-i18n.js
   UI-vertalingen NL/EN/DE/FR. De widget kiest de taal via window.DSW_LOCALE
   (geïnjecteerd door de Liquid via request.locale). Fallback = nl.
   Placeholders: {breed} {size} {next} {max} {min} {cm} {step} {total} */

window.DSW_I18N = {

  /* ====================== NEDERLANDS (bron) ====================== */
  nl: {
    header_title: 'Vind de juiste maat voor jouw hond',

    s0_title: 'Hoe wil je de maat bepalen?',
    s0_sub: 'Kies de methode die het beste bij je past. Beide leiden tot hetzelfde resultaat.',
    s0_breed_title: 'Ik ken het ras',
    s0_breed_desc: 'Zoek het ras van je hond en wij berekenen de maat op basis van de gemiddelde pootbreedte.',
    s0_measure_title: 'Ik wil zelf opmeten',
    s0_measure_desc: 'Meet de pootbreedte met een liniaal (de meest nauwkeurige methode).',
    s0_tip_label: 'Tip:',
    s0_tip_text: 'Heb je sokken van een ander merk? Dan kan het lijken alsof onze maten groter uitvallen. Dat komt doordat verschillende merken hun maatvoering anders berekenen.',

    nav_back: '← Terug',
    crumb_breed: 'Via ras',
    crumb_measure: 'Opmeten',

    s1a_title: 'Welk ras heeft jouw hond?',
    s1a_sub: 'Typ (een deel van) het ras. Staat het er niet bij? Gebruik dan de meetmethode.',
    s1a_placeholder: 'Bijv. Labrador, Golden, Beagle…',
    no_results: 'Geen ras gevonden. Probeer de <strong>meetmethode</strong> of typ een Engelse rasnaam.',

    s1b_title_pre: 'Hoe zwaar is jouw ',
    s1b_title_post: '?',
    s1b_sub: 'Het gewicht bepaalt de typische pootbreedte binnen het ras. Bij twijfel: kies "Gemiddeld".',
    s1b_small: 'Lichter dan gemiddeld',
    s1b_avg: 'Gemiddeld gewicht',
    s1b_large: 'Zwaarder dan gemiddeld',
    weight_small_desc: 'Weegt minder dan {max} kg, duidelijk lichter dan typisch voor de {breed}',
    weight_avg_desc: 'Weegt {min}–{max} kg, typisch gewicht voor de {breed}',
    weight_large_desc: 'Weegt meer dan {min} kg, zwaargebouwd en boven het rasgemiddelde',
    variant_small_word: 'kleiner',
    variant_avg_word: 'gemiddeld',
    variant_large_word: 'groter',

    s1c_title: 'Meet de pootbreedte',
    s1c_diag1: 'Trek links en rechts een streepje',
    s1c_diag2: 'en meet de afstand tussen de 2 streepjes.',
    s1c_step1: 'Zet je hond op een <strong>harde, vlakke ondergrond</strong>, volledig gewicht op alle poten, tenen gespreid.',
    s1c_step2: 'Trek een streepje <strong>links</strong> en <strong>rechts</strong> naast de poot op het breedste punt. Meet daarna de afstand.',
    s1c_step3: 'Lees af in <strong>centimeter</strong>. Niet de enkel of nagels, alleen de breedte van de pootafdruk.',
    s1c_svg: 'pootbreedte',
    cm_step_hint: 'stappen van 0,1 cm',
    s1c_next: 'Volgende stap →',

    s2_title: 'Hoe is de vacht van je hond?',
    s2_sub: 'Dikke vacht vergroot de poot visueel, we corrigeren hier automatisch voor.',
    s2_low_label: 'Kortharig of kaal',
    s2_low_desc: 'Huid goed zichtbaar, haren korter dan 1 cm (bijv. Labrador, Boxer, Weimaraner).',
    s2_mid_label: 'Middellang of ruig',
    s2_mid_desc: 'Haren van 1–3 cm, licht uitstaand (bijv. Beagle, Border Collie, Husky).',
    s2_high_label: 'Lang of pluizig',
    s2_high_desc: 'Dikke pluizen of haren over de poot (bijv. Berner Sennen, Samoyed, Chow Chow).',

    s3_result_label: 'Aanbevolen maat',
    s3_range_pre: 'Pootbreedte ',
    s3_tag_default: '🐾 Berekend voor jouw hond',
    senior_title: '🐾 Senior hond: extra voordeel',
    senior_text: 'Dog Socky helpt artrose- en heupdysplasiehonden dagelijks hun balans te bewaren op gladde vloeren.',
    borderline_title: '⚠️ Grenswaarde',
    why_title: 'Hoe we dit berekend hebben',
    calc_label_paw: 'Pootbreedte',
    calc_paw_breed: 'Gem. pootbreedte ({breed})',
    calc_measured: 'Gemeten pootbreedte',
    calc_light: 'Lichte variant (×0,92)',
    calc_heavy: 'Zware variant (×1,08)',
    calc_fur: 'Vachtcorrectie (+0,7 cm)',
    calc_total_label: 'Geschatte pootbreedte',
    cta_pre: 'Bestel maat ',
    cta_post: ', €19,95 →',
    cta_sub: 'Gratis verzending · 30-dagen maatruil · Geleverd in 2–3 werkdagen',
    safety_title: '👆 Veiligheidstip: klittenband',
    safety_text: 'Vuistregel: <strong>twee vingers moeten comfortabel onder de band passen</strong>. Controleer de poten na 2 uur bij eerste gebruik.',
    reset: '↺ Opnieuw beginnen',
    reset_other: '↺ Andere hond meten',

    progress_step: 'Stap {step} van {total}',
    progress_result: 'Resultaat',
    result_tag_breed: '🐾 {breed} · ~{cm} cm',
    result_tag_measured: '📏 Gemeten: {cm} cm',
    borderline_xl_xxl: 'De {breed} zit op de grens van XL en XXL. Grote of zwaargebouwde exemplaren kunnen XL te klein vinden. Twijfel? Meet de pootbreedte voor zekerheid.',
    borderline_upper: 'Je hond zit aan de bovengrens van maat {size}. Bij twijfel raden we maat {next} aan. Gebruik onze <strong>30-dagen gratis maatruil</strong>.',
    borderline_lower: 'Je hond zit aan de ondergrens van maat {size}. Als de sok te los aanvoelt, kies dan één maat kleiner. Gebruik onze <strong>30-dagen gratis maatruil</strong>.',
    borderline_fur_cap: 'Met de vachtcorrectie komt je hond net boven maat {size} uit. Scheer de vacht tussen de tenen kort, dan past {size} goed. Twijfel je? Meet de pootbreedte na.',
    soldout_title: '📦 Maat {size} is tijdelijk uitverkocht',
    soldout_text: 'Nieuwe voorraad is onderweg. Laat je e-mailadres achter, dan krijg je een seintje zodra maat {size} weer leverbaar is.',
    soldout_btn: 'Stuur me een seintje',
    soldout_sent: '✅ Ingeschreven! We mailen je zodra maat {size} weer leverbaar is.',
  },

  /* ====================== ENGLISH ====================== */
  en: {
    header_title: 'Find the right size for your dog',

    s0_title: 'How would you like to find the size?',
    s0_sub: 'Pick whichever method suits you best. Both lead to the same result.',
    s0_breed_title: 'I know the breed',
    s0_breed_desc: 'Search your dog’s breed and we’ll calculate the size based on the average paw width.',
    s0_measure_title: 'I’d rather measure',
    s0_measure_desc: 'Measure the paw width with a ruler (the most accurate method).',
    s0_tip_label: 'Tip:',
    s0_tip_text: 'Wearing socks from another brand? Ours may seem to run larger. That’s because different brands calculate their sizing differently.',

    nav_back: '← Back',
    crumb_breed: 'By breed',
    crumb_measure: 'Measure',

    s1a_title: 'What breed is your dog?',
    s1a_sub: 'Type (part of) the breed. Not listed? Use the measuring method instead.',
    s1a_placeholder: 'E.g. Labrador, Golden, Beagle…',
    no_results: 'No breed found. Try the <strong>measuring method</strong> or type an English breed name.',

    s1b_title_pre: 'How heavy is your ',
    s1b_title_post: '?',
    s1b_sub: 'Weight determines the typical paw width within the breed. When in doubt, choose “Average”.',
    s1b_small: 'Lighter than average',
    s1b_avg: 'Average weight',
    s1b_large: 'Heavier than average',
    weight_small_desc: 'Weighs less than {max} kg, clearly lighter than typical for the {breed}',
    weight_avg_desc: 'Weighs {min}–{max} kg, typical weight for the {breed}',
    weight_large_desc: 'Weighs more than {min} kg, heavy-set and above the breed average',
    variant_small_word: 'smaller',
    variant_avg_word: 'average',
    variant_large_word: 'larger',

    s1c_title: 'Measure the paw width',
    s1c_diag1: 'Draw a mark on the left and right',
    s1c_diag2: 'and measure the distance between the 2 marks.',
    s1c_step1: 'Place your dog on a <strong>hard, flat surface</strong>, full weight on all paws, toes spread.',
    s1c_step2: 'Draw a mark on the <strong>left</strong> and <strong>right</strong> of the paw at its widest point. Then measure the distance.',
    s1c_step3: 'Read it in <strong>centimetres</strong>. Not the ankle or nails, only the width of the paw print.',
    s1c_svg: 'paw width',
    cm_step_hint: 'steps of 0.1 cm',
    s1c_next: 'Next step →',

    s2_title: 'What is your dog’s coat like?',
    s2_sub: 'A thick coat makes the paw look bigger; we correct for that automatically.',
    s2_low_label: 'Short-haired or hairless',
    s2_low_desc: 'Skin clearly visible, hair shorter than 1 cm (e.g. Labrador, Boxer, Weimaraner).',
    s2_mid_label: 'Medium or wiry',
    s2_mid_desc: 'Hair of 1–3 cm, slightly standing out (e.g. Beagle, Border Collie, Husky).',
    s2_high_label: 'Long or fluffy',
    s2_high_desc: 'Thick tufts or hair over the paw (e.g. Bernese Mountain Dog, Samoyed, Chow Chow).',

    s3_result_label: 'Recommended size',
    s3_range_pre: 'Paw width ',
    s3_tag_default: '🐾 Calculated for your dog',
    senior_title: '🐾 Senior dog: extra benefit',
    senior_text: 'Dog Socky helps dogs with arthritis and hip dysplasia keep their balance on slippery floors every day.',
    borderline_title: '⚠️ Borderline value',
    why_title: 'How we calculated this',
    calc_label_paw: 'Paw width',
    calc_paw_breed: 'Avg. paw width ({breed})',
    calc_measured: 'Measured paw width',
    calc_light: 'Light variant (×0.92)',
    calc_heavy: 'Heavy variant (×1.08)',
    calc_fur: 'Coat correction (+0.7 cm)',
    calc_total_label: 'Estimated paw width',
    cta_pre: 'Order size ',
    cta_post: ', €19.95 →',
    cta_sub: 'Free shipping · 30-day size exchange · Fast EU delivery',
    safety_title: '👆 Safety tip: hook-and-loop strap',
    safety_text: 'Rule of thumb: <strong>two fingers should fit comfortably under the strap</strong>. Check the paws after 2 hours on first use.',
    reset: '↺ Start over',
    reset_other: '↺ Measure another dog',

    progress_step: 'Step {step} of {total}',
    progress_result: 'Result',
    result_tag_breed: '🐾 {breed} · ~{cm} cm',
    result_tag_measured: '📏 Measured: {cm} cm',
    borderline_xl_xxl: 'The {breed} sits on the border between XL and XXL. Large or heavy-set dogs may find XL too small. Unsure? Measure the paw width to be certain.',
    borderline_upper: 'Your dog is at the upper limit of size {size}. When in doubt we recommend size {next}. Use our <strong>30-day free size exchange</strong>.',
    borderline_lower: 'Your dog is at the lower limit of size {size}. If the sock feels too loose, choose one size smaller. Use our <strong>30-day free size exchange</strong>.',
    borderline_fur_cap: 'With the coat correction your dog ends up just above size {size}. Trim the hair between the toes and {size} will fit. Not sure? Measure the paw width.',
    soldout_title: '📦 Size {size} is temporarily sold out',
    soldout_text: 'New stock is on its way. Leave your email address and we’ll let you know as soon as size {size} is back in stock.',
    soldout_btn: 'Notify me',
    soldout_sent: '✅ Signed up! We’ll email you as soon as size {size} is back in stock.',
  },

  /* ====================== DEUTSCH ====================== */
  de: {
    header_title: 'Finde die richtige Größe für deinen Hund',

    s0_title: 'Wie möchtest du die Größe bestimmen?',
    s0_sub: 'Wähle die Methode, die am besten zu dir passt. Beide führen zum gleichen Ergebnis.',
    s0_breed_title: 'Ich kenne die Rasse',
    s0_breed_desc: 'Suche die Rasse deines Hundes und wir berechnen die Größe anhand der durchschnittlichen Pfotenbreite.',
    s0_measure_title: 'Ich möchte selbst messen',
    s0_measure_desc: 'Miss die Pfotenbreite mit einem Lineal (die genaueste Methode).',
    s0_tip_label: 'Tipp:',
    s0_tip_text: 'Trägt dein Hund Socken einer anderen Marke? Dann wirken unsere Größen vielleicht größer. Das liegt daran, dass verschiedene Marken ihre Größen unterschiedlich berechnen.',

    nav_back: '← Zurück',
    crumb_breed: 'Nach Rasse',
    crumb_measure: 'Messen',

    s1a_title: 'Welche Rasse hat dein Hund?',
    s1a_sub: 'Tippe (einen Teil) der Rasse. Nicht dabei? Dann nutze die Messmethode.',
    s1a_placeholder: 'Z. B. Labrador, Golden, Beagle…',
    no_results: 'Keine Rasse gefunden. Probiere die <strong>Messmethode</strong> oder tippe einen englischen Rassenamen.',

    s1b_title_pre: 'Wie schwer ist dein ',
    s1b_title_post: '?',
    s1b_sub: 'Das Gewicht bestimmt die typische Pfotenbreite innerhalb der Rasse. Im Zweifel: wähle „Durchschnittlich“.',
    s1b_small: 'Leichter als der Durchschnitt',
    s1b_avg: 'Durchschnittliches Gewicht',
    s1b_large: 'Schwerer als der Durchschnitt',
    weight_small_desc: 'Wiegt weniger als {max} kg, deutlich leichter als typisch für den {breed}',
    weight_avg_desc: 'Wiegt {min}–{max} kg, typisches Gewicht für den {breed}',
    weight_large_desc: 'Wiegt mehr als {min} kg, schwer gebaut und über dem Rassedurchschnitt',
    variant_small_word: 'kleiner',
    variant_avg_word: 'durchschnittlich',
    variant_large_word: 'größer',

    s1c_title: 'Miss die Pfotenbreite',
    s1c_diag1: 'Zeichne links und rechts einen Strich',
    s1c_diag2: 'und miss den Abstand zwischen den 2 Strichen.',
    s1c_step1: 'Stell deinen Hund auf einen <strong>harten, ebenen Untergrund</strong>, volles Gewicht auf allen Pfoten, Zehen gespreizt.',
    s1c_step2: 'Zeichne einen Strich <strong>links</strong> und <strong>rechts</strong> neben der Pfote an der breitesten Stelle. Miss dann den Abstand.',
    s1c_step3: 'Lies in <strong>Zentimetern</strong> ab. Nicht das Gelenk oder die Krallen, nur die Breite des Pfotenabdrucks.',
    s1c_svg: 'Pfotenbreite',
    cm_step_hint: 'Schritte von 0,1 cm',
    s1c_next: 'Nächster Schritt →',

    s2_title: 'Wie ist das Fell deines Hundes?',
    s2_sub: 'Dichtes Fell lässt die Pfote größer wirken, das korrigieren wir automatisch.',
    s2_low_label: 'Kurzhaarig oder haarlos',
    s2_low_desc: 'Haut gut sichtbar, Haare kürzer als 1 cm (z. B. Labrador, Boxer, Weimaraner).',
    s2_mid_label: 'Mittellang oder drahtig',
    s2_mid_desc: 'Haare von 1–3 cm, leicht abstehend (z. B. Beagle, Border Collie, Husky).',
    s2_high_label: 'Lang oder flauschig',
    s2_high_desc: 'Dichte Büschel oder Haare über der Pfote (z. B. Berner Sennenhund, Samojede, Chow Chow).',

    s3_result_label: 'Empfohlene Größe',
    s3_range_pre: 'Pfotenbreite ',
    s3_tag_default: '🐾 Für deinen Hund berechnet',
    senior_title: '🐾 Senior-Hund: extra Vorteil',
    senior_text: 'Dog Socky hilft Hunden mit Arthrose und Hüftdysplasie, täglich ihr Gleichgewicht auf glatten Böden zu halten.',
    borderline_title: '⚠️ Grenzwert',
    why_title: 'So haben wir das berechnet',
    calc_label_paw: 'Pfotenbreite',
    calc_paw_breed: 'Durchschn. Pfotenbreite ({breed})',
    calc_measured: 'Gemessene Pfotenbreite',
    calc_light: 'Leichte Variante (×0,92)',
    calc_heavy: 'Schwere Variante (×1,08)',
    calc_fur: 'Fellkorrektur (+0,7 cm)',
    calc_total_label: 'Geschätzte Pfotenbreite',
    cta_pre: 'Größe ',
    cta_post: ' bestellen, €19,95 →',
    cta_sub: 'Kostenloser Versand · 30 Tage Größenumtausch · Schnelle EU-Lieferung',
    safety_title: '👆 Sicherheitstipp: Klettverschluss',
    safety_text: 'Faustregel: <strong>zwei Finger sollten bequem unter das Band passen</strong>. Kontrolliere die Pfoten beim ersten Tragen nach 2 Stunden.',
    reset: '↺ Von vorne beginnen',
    reset_other: '↺ Anderen Hund messen',

    progress_step: 'Schritt {step} von {total}',
    progress_result: 'Ergebnis',
    result_tag_breed: '🐾 {breed} · ~{cm} cm',
    result_tag_measured: '📏 Gemessen: {cm} cm',
    borderline_xl_xxl: 'Der {breed} liegt an der Grenze zwischen XL und XXL. Große oder schwer gebaute Exemplare finden XL evtl. zu klein. Unsicher? Miss die Pfotenbreite zur Sicherheit.',
    borderline_upper: 'Dein Hund liegt an der Obergrenze von Größe {size}. Im Zweifel empfehlen wir Größe {next}. Nutze unseren <strong>kostenlosen 30-Tage-Größenumtausch</strong>.',
    borderline_lower: 'Dein Hund liegt an der Untergrenze von Größe {size}. Wenn die Socke zu locker sitzt, wähle eine Größe kleiner. Nutze unseren <strong>kostenlosen 30-Tage-Größenumtausch</strong>.',
    borderline_fur_cap: 'Mit der Fellkorrektur liegt dein Hund knapp über Größe {size}. Schneide das Haar zwischen den Zehen kurz, dann passt {size}. Unsicher? Miss die Pfotenbreite nach.',
    soldout_title: '📦 Größe {size} ist vorübergehend ausverkauft',
    soldout_text: 'Neue Ware ist unterwegs. Hinterlass deine E-Mail-Adresse, dann sagen wir dir Bescheid, sobald Größe {size} wieder lieferbar ist.',
    soldout_btn: 'Benachrichtige mich',
    soldout_sent: '✅ Eingetragen! Wir mailen dir, sobald Größe {size} wieder lieferbar ist.',
  },

  /* ====================== FRANÇAIS ====================== */
  fr: {
    header_title: 'Trouvez la bonne taille pour votre chien',

    s0_title: 'Comment voulez-vous déterminer la taille ?',
    s0_sub: 'Choisissez la méthode qui vous convient le mieux. Les deux mènent au même résultat.',
    s0_breed_title: 'Je connais la race',
    s0_breed_desc: 'Cherchez la race de votre chien et nous calculons la taille selon la largeur moyenne de la patte.',
    s0_measure_title: 'Je préfère mesurer',
    s0_measure_desc: 'Mesurez la largeur de la patte avec une règle (la méthode la plus précise).',
    s0_tip_label: 'Astuce :',
    s0_tip_text: 'Votre chien porte des chaussettes d’une autre marque ? Les nôtres peuvent sembler plus grandes. C’est parce que chaque marque calcule ses tailles différemment.',

    nav_back: '← Retour',
    crumb_breed: 'Par race',
    crumb_measure: 'Mesurer',

    s1a_title: 'Quelle est la race de votre chien ?',
    s1a_sub: 'Tapez (une partie de) la race. Absente ? Utilisez alors la méthode de mesure.',
    s1a_placeholder: 'Ex. Labrador, Golden, Beagle…',
    no_results: 'Aucune race trouvée. Essayez la <strong>méthode de mesure</strong> ou tapez un nom de race en anglais.',

    s1b_title_pre: 'Quel est le poids de votre ',
    s1b_title_post: ' ?',
    s1b_sub: 'Le poids détermine la largeur de patte typique au sein de la race. En cas de doute : choisissez « Moyen ».',
    s1b_small: 'Plus léger que la moyenne',
    s1b_avg: 'Poids moyen',
    s1b_large: 'Plus lourd que la moyenne',
    weight_small_desc: 'Pèse moins de {max} kg, nettement plus léger que la moyenne du {breed}',
    weight_avg_desc: 'Pèse {min}–{max} kg, poids typique du {breed}',
    weight_large_desc: 'Pèse plus de {min} kg, robuste et au-dessus de la moyenne de la race',
    variant_small_word: 'plus petit',
    variant_avg_word: 'moyen',
    variant_large_word: 'plus grand',

    s1c_title: 'Mesurez la largeur de la patte',
    s1c_diag1: 'Tracez un trait à gauche et à droite',
    s1c_diag2: 'et mesurez la distance entre les 2 traits.',
    s1c_step1: 'Placez votre chien sur une <strong>surface dure et plane</strong>, tout le poids sur les pattes, doigts écartés.',
    s1c_step2: 'Tracez un trait à <strong>gauche</strong> et à <strong>droite</strong> de la patte à son point le plus large. Mesurez ensuite la distance.',
    s1c_step3: 'Lisez en <strong>centimètres</strong>. Pas la cheville ni les griffes, seulement la largeur de l’empreinte.',
    s1c_svg: 'largeur de patte',
    cm_step_hint: 'pas de 0,1 cm',
    s1c_next: 'Étape suivante →',

    s2_title: 'Comment est le pelage de votre chien ?',
    s2_sub: 'Un pelage épais fait paraître la patte plus grande ; nous le corrigeons automatiquement.',
    s2_low_label: 'Poil court ou nu',
    s2_low_desc: 'Peau bien visible, poils plus courts que 1 cm (ex. Labrador, Boxer, Weimaraner).',
    s2_mid_label: 'Mi-long ou dur',
    s2_mid_desc: 'Poils de 1–3 cm, légèrement dressés (ex. Beagle, Border Collie, Husky).',
    s2_high_label: 'Long ou touffu',
    s2_high_desc: 'Touffes épaisses ou poils sur la patte (ex. Bouvier Bernois, Samoyède, Chow Chow).',

    s3_result_label: 'Taille recommandée',
    s3_range_pre: 'Largeur de patte ',
    s3_tag_default: '🐾 Calculé pour votre chien',
    senior_title: '🐾 Chien senior : avantage en plus',
    senior_text: 'Dog Socky aide chaque jour les chiens souffrant d’arthrose et de dysplasie de la hanche à garder leur équilibre sur les sols glissants.',
    borderline_title: '⚠️ Valeur limite',
    why_title: 'Comment nous avons calculé',
    calc_label_paw: 'Largeur de patte',
    calc_paw_breed: 'Largeur moy. de patte ({breed})',
    calc_measured: 'Largeur de patte mesurée',
    calc_light: 'Variante légère (×0,92)',
    calc_heavy: 'Variante lourde (×1,08)',
    calc_fur: 'Correction pelage (+0,7 cm)',
    calc_total_label: 'Largeur de patte estimée',
    cta_pre: 'Commander la taille ',
    cta_post: ', 19,95 € →',
    cta_sub: 'Livraison gratuite · Échange de taille 30 jours · Livraison rapide en UE',
    safety_title: '👆 Conseil de sécurité : velcro',
    safety_text: 'Règle d’or : <strong>deux doigts doivent passer confortablement sous la bande</strong>. Vérifiez les pattes après 2 heures lors de la première utilisation.',
    reset: '↺ Recommencer',
    reset_other: '↺ Mesurer un autre chien',

    progress_step: 'Étape {step} sur {total}',
    progress_result: 'Résultat',
    result_tag_breed: '🐾 {breed} · ~{cm} cm',
    result_tag_measured: '📏 Mesuré : {cm} cm',
    borderline_xl_xxl: 'Le {breed} se situe à la limite entre XL et XXL. Les chiens grands ou robustes peuvent trouver le XL trop petit. Un doute ? Mesurez la largeur de patte par sécurité.',
    borderline_upper: 'Votre chien est à la limite supérieure de la taille {size}. En cas de doute, nous recommandons la taille {next}. Profitez de notre <strong>échange de taille gratuit 30 jours</strong>.',
    borderline_lower: 'Votre chien est à la limite inférieure de la taille {size}. Si la chaussette est trop lâche, choisissez une taille en dessous. Profitez de notre <strong>échange de taille gratuit 30 jours</strong>.',
    borderline_fur_cap: 'Avec la correction pour le poil, votre chien dépasse à peine la taille {size}. Coupez le poil entre les doigts et le {size} conviendra. Un doute ? Mesurez la largeur de la patte.',
    soldout_title: '📦 La taille {size} est temporairement épuisée',
    soldout_text: 'Du nouveau stock est en route. Laissez votre adresse e-mail et nous vous préviendrons dès que la taille {size} sera de nouveau disponible.',
    soldout_btn: 'Prévenez-moi',
    soldout_sent: '✅ Inscrit ! Nous vous écrirons dès que la taille {size} sera de nouveau disponible.',
  },
};
